import React from "react"

import { Text, VStack } from "@chakra-ui/react"

import { Heading } from "./Heading"

type Props = {
  step: number
  heading: string
}

export const StepHeading = ({ step, heading }: Props) => {
  return (
    <VStack align="flex-start" spacing={0}>
      <Text
        fontSize={{ base: 12, sm: 14 }}
        lineHeight={{ base: 1.2, sm: 1.85 }}
        fontWeight={400}
        style={{ userSelect: "none" }}
      >
        Step {step}
      </Text>
      <Heading heading={heading} />
    </VStack>
  )
}
